import phase1 from "../assets/images/phase1.png";
import phase2 from "../assets/images/phase2.png";
import phase3 from "../assets/images/phase3.png";

const phases = [
  {
    id: 1,
    title: "Phase 1: Introduction to Sounds (Ages 3-4)",
    image: phase1,
    content:
      "This phase is all about sparking curiosity and introducing the core elements of Jolly Phonics in a fun, multi-sensory way. It's ideal for pre-readers and those beginning their literacy journey.",
    description: [
      {
        subtitle: "Key Learning Objectives:",
        points: `Learning the 42 Letter Sounds (Initial Groups): We introduce the 42 main sounds of English, starting with the first groups (s, a, t, i, p, n; then c/k, e, h, r, m, d, etc.) which allow for early blending.`,
      },
      {
        subtitle: "Online Approach: Each sound gets its own dedicated module.",
        points1: `Interactive Video Lessons: Engaging animations and your expert instruction demonstrating the sound, action, and accompanying story/song.`,
        points2: `Sound Recognition Games: Drag-and-drop activities, click-to-hear games, and interactive flashcards to reinforce auditory discrimination.`,
        points3: `Letter Formation Practice: Animated guides for correct letter formation (e.g., tracing on screen, printable worksheets for offline practice with correct stroke order).`,
      },
      {
        subtitle: "Simple Blending Introduction: ",
        points: `Early blending of two and three-letter CVC (consonant-vowel-consonant) words using the sounds learned so far (e.g., s-a-t, p-i-n). This will be highly interactive with clickable sounds that blend into a word.`,
      },
      {
        subtitle: "Oral Segmenting Activities:",
        points: `Games where children hear a word and identify the individual sounds (e.g., "What sounds do you hear in 'cat'?").`,
      },
      {
        subtitle: "Emphasis: ",
        points: `Multi-sensory learning (visual, auditory, kinesthetic through actions), developing phonemic awareness, and building a foundation for blending.`,
      },
      {
        subtitle: "Parent Involvement: ",
        points: `Clear guidance for parents on how to reinforce learning at home with everyday activities.`,
      },
    ],
  },
  {
    id: 2,
    title: "Word Builders & Early Readers (Age 5 years onwards)",
    image: phase2,
    content:
      "In this phase, learners consolidate their understanding of single letter sounds and begin to apply their knowledge to read and write more confidently.",
    description: [
      {
        subtitle: "Key Learning Objectives:",
        points: `Mastering All 42 Letter Sounds: Review and solidify all 42 sounds, including digraphs (two letters making one sound like 'sh', 'th', 'ch', 'ai', 'ee', 'or') and common tricky sounds.`,
      },
      {
        subtitle: "Online Approach:",
        points1: `Digraph Spotlight Modules: Dedicated lessons for each digraph, following the same multi-sensory approach as single sounds.`,
        points2: `Advanced Blending Practice: More complex CVC words, words with digraphs, and introduction to consonant blends (e.g., 'bl' in 'blue', 'st' in 'stop'). Interactive blending exercises with immediate feedback.`,
        points3: `Segmenting for Spelling: Activities where children segment words into sounds and choose the correct graphemes to spell them.`,
      },
      {
        subtitle: `Introducing "Tricky Words": `,
        points: `Systematic introduction of the first sets of irregular high-frequency words (e.g., "the," "I," "was," "said") using visual memory techniques and 'look, cover, write, check' online tools.`,
      },
      {
        subtitle: "Early Decodable Readers: ",
        points: `Short, engaging decodable stories and sentences built primarily from sounds they've learned, with interactive read-aloud options and comprehension questions.`,
      },
      {
        subtitle: "Emphasis: ",
        points: `Fluency in blending and segmenting, initial spelling skills, and building confidence in reading simple sentences.`,
      },
      {
        subtitle: "Parent Involvement: ",
        points: `Encouragement to engage in shared reading of decodable books and practice tricky words together.`,
      },
    ],
  },
  {
    id: 3,
    title: "Fluent Readers & Creative Writers (Ages 6 - 7.5+ Years)",
    image: phase3,
    content:
      `Duration: Approximately 8-10 Months (2-3 sessions per week, 45-60 mins each)

This advanced phase focuses on refining reading fluency, expanding vocabulary, tackling more complex spelling patterns, and developing independent writing skills. It often integrates aspects of Jolly Grammar.`,
    description: [
      {
        subtitle: "Key Learning Objectives:",
        points: `Alternative Spellings: Introduction to various ways of spelling the same sound (e.g., long 'a' sound can be 'ai', 'ay', 'a_e', 'eigh').`,
      },
      {
        subtitle: "Online Approach:",
        points1: `Spelling Pattern Focus Modules: Deep dives into different spelling patterns for vowel sounds and other common phonemes. Interactive sorting and matching games for these patterns.`,
        points2: `Advanced Tricky Words: Continued learning of irregular high-frequency words, with strategies like mnemonics and breaking down tricky parts.`,
        points3: `Reading Comprehension: Engaging stories (decodable and increasingly more complex texts) with interactive comprehension questions, prediction activities, and vocabulary building exercises.`,
      },
      {
        subtitle: `Sentence Construction & Grammar Basics:  `,
        points: `Introduction to basic sentence structure, capitalization, punctuation, and common grammatical concepts (nouns, verbs, adjectives) integrated with reading and writing.`,
      },
      {
        subtitle: "Guided Writing Activities: ",
        points: `Prompts and scaffolds for writing simple sentences, short paragraphs, and creative stories, encouraging the application of learned phonics and grammar rules.`,
      },
      {
        subtitle: "Dictation Exercises: ",
        points: `Interactive dictation where children type or select letters/words based on spoken sentences.`,
      },
      {
        subtitle: "Emphasis: ",
        points: `Reading fluency, accurate spelling, comprehension, expanding vocabulary, and fostering creative writing`,
      },
    ],
  }
];

export { phases };